import { Box, Button, Grid2, TextField, Typography } from "@mui/material";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/MainLayout";
import PollCard from "../../components/PollCard";
import { useSidebarCounts } from "../../context/SidebarCountsContext";
import axiosInstance from "../../utils/axiosInstance";

export default function Polls() {
  const { updateCount } = useSidebarCounts();

  const [polls, setPolls] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPolls = useCallback(
    async (page = 1, search = "") => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/polls/paginated?page=${page}&search=${search}`,
        );

        if (response.status === 200) {
          setPolls(response.data.data); // 'data' contains the paginated items
          setTotalPages(response.data.last_page); // 'last_page' contains the total number of pages
          updateCount();
        }
      } catch (error) {}
    },
    [updateCount],
  );

  useEffect(() => {
    fetchPolls(currentPage, searchTerm);
  }, [fetchPolls, currentPage, searchTerm]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // Debounce the search input to reduce API calls
  const handleSearchChange = debounce((e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  }, 400);

  return (
    <MainLayout>
      <Typography variant="h6">Polls</Typography>

      {/* Search Input */}
      <Box my={3}>
        <TextField
          fullWidth
          variant="outlined"
          onChange={handleSearchChange}
          placeholder="Search by title..."
        />
      </Box>

      <Grid2 container spacing={2}>
        {polls &&
          polls.map((poll) => (
            <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={poll.id}>
              <PollCard
                poll={poll}
                onDelete={fetchPolls}
                onUpdate={() => {
                  fetchPolls(currentPage, searchTerm);
                }}
              />
            </Grid2>
          ))}
      </Grid2>

      {/* Pagination Controls */}
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <Button
          variant="contained"
          // disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </Button>

        <Typography sx={{ mx: 2, display: "flex", alignItems: "center" }}>
          Page {currentPage} of {totalPages}
        </Typography>

        <Button
          variant="contained"
          // disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </Button>
      </Box>
    </MainLayout>
  );
}
